import axiosplugin from '../adm/axiosplugin'
//import config from '../../config';
//const CancelToken = axiosplugin.CancelToken;
//const source = CancelToken.source();
export default {
  /*cancelCall(){
    source.cancel('Operation canceled.');
  },/**/ 
  async callDataAPI (page) {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('rows', config.CAMERAS_PER_SERVER);
    return new Promise(async function (resolve,reject) {
      await axiosplugin.get((config.VUE_APP_QUERY || process.env.VUE_APP_QUERY) + "/api/v2/resources/cameras",{params:params})
      .then((response)=>{
        resolve(response.data)
      }
      //, {cancelToken: source.token}
      )
      .catch((err) =>{
        reject(err)
      })
    })
  },

  async retrieveSearch (searchquery) {
    const params = new URLSearchParams();
    params.append('query', searchquery);
    return new Promise(async function (resolve,reject) {
      await axiosplugin.get((config.VUE_APP_QUERY || process.env.VUE_APP_QUERY) + "/api/v2/resources/cameras/search", {params:params})
      .then((response)=>{
        
        resolve(response.data)
      }
      //, {cancelToken: source.token}
      )
      .catch((err) =>{
        reject(err)
      })
    })
  }
}
